export const LEARN_MORE = 'learn_more';
export const LEARN_MORE_BACKGROUND = 'learn_more_background';
export const LEARN_MORE_CLASSIFICATION = 'learn_more_classification';
export const SPECIAL_TERMS = 'special_terms';
export const COMPLIANCE_SOURCE_QUERY_KEY = 'compliance_source';

export const DEFAULT_BC_TYPE = 'ICS';
